module.exports = __webpack_public_path__ + "static/media/icon-pipelines.d732c320.svg";